<template>
  <div class="mb-8">
    <div class="d-flex align-center justify-space-between flex-wrap ga-3 mb-4">
      <div class="font-size-14 d-flex align-center ga-1">
        <span class="font-weight-bold">{{ config.title }}</span>
        <span class="text-disabled">({{ contacts.length }})</span>
      </div>

      <v-btn
        v-if="!readonly"
        prepend-icon="mdi-plus"
        @click="openContactDialog(type)">
        {{ config.addLabel }}
      </v-btn>
    </div>

    <v-card>
      <v-card-text>
        <v-data-table
          v-if="contacts.length"
          :headers="headers"
          :hide-default-footer="true"
          :items="contacts"
          :items-per-page="-1">
          <template #item.type="{ item }">
            <v-chip class="font-weight-bold" variant="tonal">
              {{ item.type?.name }}
            </v-chip>
          </template>

          <template #item.value="{ item }">
            <a
              v-if="type === 'email'"
              :href="`mailto:${contactValue(type, item)}`"
              class="text-primary text-decoration-none">
              {{ contactValue(type, item) }}
            </a>
            <span v-else>{{ contactValue(type, item) }}</span>
          </template>

          <template #item.actions="{ item }">
            <b-action-menu
              :actions="[
                {
                  title: 'Редагувати',
                  icon: 'mdi-pencil',
                  action: () => openContactDialog(type, item),
                  iconProps: {
                    color: 'blue-darken-3',
                  },
                  disabled: readonly,
                },
                {
                  title: 'Видалити',
                  icon: 'mdi-delete-forever',
                  action: () => deleteContact(type, item.id),
                  listItemProps: {
                    class: 'text-error',
                  },
                  iconProps: {
                    color: 'error',
                  },
                  disabled: readonly,
                },
              ]"
              :btnProps="{ density: 'compact' }"></b-action-menu>
          </template>

          <template #bottom></template>
        </v-data-table>
        <empty-section v-else :title="config.emptyTitle" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { computed, PropType } from 'vue'
import { useContractorStore } from '@/pages/contractor/single/contractor'
import EmptySection from '@/components/EmptySection.vue'
import { BActionMenu } from 'best-modules/components'
import type { ContractorContactType } from '@/utils/types/contractor'
import {
  contractorAddressHeaders,
  contractorEmailHeaders,
  contractorPhoneHeaders,
} from '@/pages/contractor/single/headers'

export default {
  name: 'ContractorContactTable',
  components: { EmptySection, BActionMenu },
  props: {
    type: {
      type: String as PropType<ContractorContactType>,
      required: true,
    },
  },
  setup(props) {
    const store = useContractorStore()
    const config = computed(() => store.contactConfigs[props.type])
    const contacts = computed(
      () => store.contractor[config.value.listKey] || []
    )
    const headers = computed(() => {
      return {
        address: contractorAddressHeaders,
        phone: contractorPhoneHeaders,
        email: contractorEmailHeaders,
      }[props.type]
    })

    return {
      ...store,
      config,
      contacts,
      headers,
    }
  },
}
</script>
